import { useEffect, useMemo, useState } from "react";
import { Check, ChevronsUpDown, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const nombre = (p) => p?.nombre || p?.razon_social || "(sin nombre)";

export const PersonaPicker = ({ value, onChange, personas, testid, filtro }) => {
  const [open, setOpen] = useState(false);
  const [recientes, setRecientes] = useState([]);
  useEffect(() => {
    api.get("/personas/recientes").then((r) => setRecientes(r.data)).catch(() => {});
  }, []);
  const lista = useMemo(() => personas.filter((p) => p.rol !== "asesor" && (!filtro || filtro(p))), [personas, filtro]);
  const usadas = recientes.map((id) => lista.find((p) => p.id === id)).filter(Boolean);
  const resto = lista.filter((p) => !recientes.includes(p.id)).sort((a, b) => nombre(a).localeCompare(nombre(b), "es"));
  const actual = lista.find((p) => p.id === value);
  const item = (p) => (
    <CommandItem key={p.id} value={`${nombre(p)} ${p.id}`} onSelect={() => { onChange(p.id); setOpen(false); }} data-testid={`${testid}-opcion-${p.id}`}>
      <Check className={`w-4 h-4 mr-2 ${p.id === value ? "opacity-100" : "opacity-0"}`} />
      <span className="truncate">{nombre(p)}</span>
      {p.tipo === "moral" && <span className="ml-auto text-[10px] uppercase text-slate-400">moral</span>}
    </CommandItem>
  );
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="w-full h-14 px-4 rounded-xl border border-[#CBD5E1] bg-white text-left flex items-center justify-between gap-2">
          <span className={actual ? "text-slate-900 truncate" : "text-slate-500"}>{actual ? nombre(actual) : "Elige una persona"}</span>
          <ChevronsUpDown className="w-4 h-4 text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[280px]" align="start">
        <Command>
          <CommandInput placeholder="Buscar por nombre…" data-testid={`${testid}-buscar`} />
          <CommandList className="max-h-72">
            <CommandEmpty>No hay personas con ese nombre.</CommandEmpty>
            {usadas.length > 0 && (
              <CommandGroup heading={<span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> Usadas antes</span>} data-testid={`${testid}-recientes`}>
                {usadas.map(item)}
              </CommandGroup>
            )}
            <CommandGroup heading="Todas">{resto.map(item)}</CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
